import axios from '../../config/axiosConfig';

export default {
  // getPermissions: () => axios.post('/get_session_data'),
  auth: (data) => axios.post('/auth_email', data),
  logout: () => axios.get('/logout'),
};
